import React from 'react';
import PropTypes from 'prop-types';
import { NewTabIcon } from '../../icons';
import styles from './PriceSummaryBox.module.scss';

const PriceSummaryBox = ({
  purchasedItem,
  price,
  details,
  detailsLink = '',
  hideTotalMobile = false,
}) => {
  // Give price the appropriate comma formatting
  const formattedPrice = price.toLocaleString('en-US');

  return (
    <>
      <div className={styles.title}>Review order:</div>
      <div className={styles.content}>
        <div className={styles['item-price']}>
          <span>{purchasedItem}</span>
          <span>{`$${formattedPrice}`}</span>
        </div>
        <div className={`${styles['detail-string']} ${!detailsLink ? styles['detail-string--unlinked'] : ''} ${hideTotalMobile ? styles['detail-string--mobile-tighten'] : ''}`}>
          {detailsLink ? (
            <a href={detailsLink} target="_blank" rel="noreferrer">
              <span className={styles['link-text']}>{details}</span>
              <span className={styles['icon-wrapper']}>
                <NewTabIcon />
              </span>
            </a>
          ) : (
            <span>{details}</span>
          )}
        </div>
        <div className={`${styles['total-price']} ${hideTotalMobile ? styles['total-price--hide-mobile'] : ''}`}>
          <span>Total:</span>
          <span className={styles['total-price__number']}>{`$${formattedPrice}`}</span>
        </div>
      </div>
    </>
  );
};

PriceSummaryBox.propTypes = {
  purchasedItem: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  details: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]).isRequired,
  detailsLink: PropTypes.string,
  hideTotalMobile: PropTypes.bool,
};

export default PriceSummaryBox;
